

import Vue from 'vue'

import VueIconFont from 'vue-icon-font'
import VueScrollTo from 'vue-scrollto'
import VueTouch from 'vue-touch'
import BaiduMap from 'vue-baidu-map'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import router from './router'
import store from './store'
import App from './App'

import 'minireset.css'
import './css/app.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import '@/assets/iconfont/xmb-wap/iconfont.css'
import '@/assets/iconfont/xmb-wap/iconfont.js'
import '@/assets/iconfont/xmb-login/iconfont.css'
import '@/assets/iconfont/xmb-login/iconfont.js'

const FastClick = require('fastclick')

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(VueIconFont)
Vue.use(VueScrollTo)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(BaiduMap, {ak: 'YddmVINbOUNAY9jOgfk832QOCeAfsfuG'})

Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)

Vue.directive('transfer-dom', TransferDom)

Vue.config.productionTip = false
Vue.prototype.$store = store

FastClick.attach(document.body)

Vue.config.productionTip = false

const app = new Vue({
el: '#app-box',
router,
components: {App},
template: '<App/>'
})

app.$mount()



// WEBPACK FOOTER //
// ./src/main.js